import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "reactstrap";
import "../styles/filterList.css";
import Helmet from "../components/Helmet/Helmet";
import CommonSection from "../components/UI/CommonSection";
import CarItem from "../components/UI/CarItem";
//import carData from "../assets/data/carData";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../axiosInstance";
import { constants } from "../Utils/constants";

const CarListing = () => {
  const { findCarDetails } = useSelector((state) => state.booking);

  const [selectedCarsCategory, setSelectedCarsCategory] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [carData, setCarData] = useState([]);
  const [filteredCarsList, setFilteredCarsList] = useState(carData);

  const setCategory = () => {
    let dummyData = [...categoryList];
    filteredCarsList.filter((item) => {
      !dummyData.includes(item.brand)
        ? (dummyData = [...dummyData, item.brand])
        : (dummyData = [...dummyData]);
      !dummyData.includes(item.driveType)
        ? (dummyData = [...dummyData, item.driveType])
        : (dummyData = [...dummyData]);
      !dummyData.includes(item.fuelType)
        ? (dummyData = [...dummyData, item.fuelType])
        : (dummyData = [...dummyData]);
      !dummyData.includes(item.category)
        ? (dummyData = [...dummyData, item.category])
        : (dummyData = [...dummyData]);
    });
    setCategoryList(dummyData);
  };

  useEffect(() => {
    setCategory();
  }, [carData]);

  //--------Get all Cars----------------/branches/{branch_id}/cars
  useEffect(() => {
    console.log("in useeffect my");
    const allCarList = async () => {
      const resp = await axiosInstance.get(constants.serverUrl+`/branches/${findCarDetails.branchId}/cars`
      );
      console.log(resp.data);
      setCarData(resp.data);
      setFilteredCarsList(resp.data);
      //   if(resp.data?.status==false){
      //     toast.error(resp.data?.message, {
      //       theme: "colored",
      //     });
      //   }
      //   else{
      //   setCarData(resp.data);
      //   setFilteredCarsList(resp.data);
      // }
    };

    allCarList();
  }, []);

  useEffect(() => {
    filterItems();
  }, [selectedCarsCategory]);

  // This function does the job of changing the button colors as well as adding and removing the categories into and out of the category array which will be used for filtering further.
  const handleFilterButtonClick = (selectedCategory) => {
    if (selectedCarsCategory.includes(selectedCategory)) {
      let filters = selectedCarsCategory.filter(
        (el) => el !== selectedCategory
      );
      setSelectedCarsCategory(filters);
    } else {
      setSelectedCarsCategory([...selectedCarsCategory, selectedCategory]);
    }
  };

  const handleSelect = (e) => {
    e.target.value === "low"
      ? setFilteredCarsList(
          [...filteredCarsList].sort((a, b) => a.price - b.price)
        )
      : setFilteredCarsList(
          [...filteredCarsList].sort((a, b) => b.price - a.price)
        );
  };

  // This function does the actual job of filtering the cars based on categories array
  const filterItems = () => {
    if (selectedCarsCategory.length > 0) {
      let tempItems = selectedCarsCategory.map((selectedCategory) => {
        let temp = carData.filter(
          (item) =>
            item.driveType === selectedCategory ||
            item.brand === selectedCategory ||
            item.fuelType === selectedCategory ||
            item.category === selectedCategory
        );
        return temp;
      });
      setFilteredCarsList([...new Set(tempItems.flat())]); //This is done to remove the duplicates
    } else {
      setFilteredCarsList([...carData]);
    }
  };

  return (
    <Helmet title="Cars">
      <CommonSection title="Car Listing" />

      <section>
        <Container>
          <Row className="d-flex">
            <Col lg="2" md="3" sm="2">
              <div className=" d-flex align-items-center gap-3 mb-5">
                <span className=" d-flex align-items-center gap-2">
                  <i class="ri-sort-asc"></i> Sort By
                </span>

                <select onChange={handleSelect}>
                  <option>Select</option>
                  <option value="low">Low to High</option>
                  <option value="high">High to Low</option>
                </select>
              </div>
              <div className="d-flex flex-wrap gap-1 buttons-container">
                {categoryList.map((category) => (
                  <button
                    onClick={() => handleFilterButtonClick(category)}
                    className={`button ${
                      selectedCarsCategory?.includes(category)
                        ? "activeFilter"
                        : ""
                    }`}
                  >
                    {category}
                  </button>
                ))}
              </div>

              {/* {automaticList.map((item) => (
                <button>{item}</button>
              ))} */}
            </Col>

            <Col lg="9" md="9" sm="9">
              <div className="d-flex justify-content-start flex-wrap ms-5 gap-3">
                {filteredCarsList.map((item) => (
                  <CarItem item={item} key={item.vehicleNo} />
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default CarListing;
